export default {
  services_number_title: "Liczba usług do wyboru",
  additional_information_after_booking_title:
    "Dodatkowe informacje we wiadomości e-mail po rezerwacji",
  additional_information_after_booking_subtitle:
    "Dodatkowe informacje, które będą przesyłane w e-mailach związanych z rezerwacją usługi (utworzenie, zmiana oraz przypomnienie o rezerwacji). Jeśli edytowałeś powiadomienia, upewnij się, że w ich treści została ustawiona odpowiednia zmienna: [ADDITIONAL_INFORMATION_AFTER_BOOKING].",
  additional_information_after_booking_dummy_text:
    "To jest przykładowy tekst, który zostanie zastąpiony dodatkowymi informacjami po rezerwacji, jeśli zostały one podane w ustawieniach usługi.",
  plugins_storage_100gb_cd_base_pro_name: "Miejsce na pliki 100 GB",
  plugins_storage_500gb_cd_base_pro_name: "Miejsce na pliki 500 GB",
  plugins_storage_100gb_cd_base_pro_description:
    "Więcej miejsca na pliki. Zyskaj 100 GB dodatkowej przestrzeni na wymianę plików z klientami oraz przyjmowanie załączników przez formularze rezerwacji. Idealne rozwiązanie, które usprawni komunikację i ułatwi obsługę klientów.",
  plugins_storage_500gb_cd_base_pro_description:
    "Maksymalna przestrzeń na Twoje pliki. Skorzystaj z 500 GB przestrzeni, aby bez ograniczeń wymieniać pliki z klientami i odbierać załączniki przez formularze rezerwacji. Niezbędne dla dynamicznie rozwijających się firm, które cenią profesjonalizm i wygodę obsługi.",
  bookings_this_month: "Rezerwacje w tym miesiącu",
  bookings_all_processed: "Wszystkie rezerwacje",
  simple_store_product_transactions_this_month:
    "Sprzedane produkty w tym miesiącu",
  files_storage_usage: "Wykorzystane miejsce na pliki",
  files_storage_usage_from_available_prefix: "z dostępnych",
  not_available_in_standard_plan: "Funkcja niedostępna w planie Standard",
  ai_tokens_usage: "Wykorzystane tokeny AI",
  ai_tokens_usage_from_available_prefix: "z dostępnych",
  ai_tokens_resets_at: "Resetuje się",
  cancel_reason_dropdown_label: "Powód anulowania subskrypcji",
  cancel_subscription_category_1_title: "Problemy techniczne",
  cancel_subscription_category_1_reason_1_title:
    "Częste awarie lub przerwy w działaniu",
  cancel_subscription_category_1_reason_2_title: "Wolne działanie systemu",
  cancel_subscription_category_1_reason_3_title: "Trudny w obsłudze interfejs",
  cancel_subscription_category_1_reason_4_title:
    "Problemy z integracjami (np. system płatności, kalendarze zewnętrzne)",
  cancel_subscription_category_1_reason_5_title:
    "Obawy dotyczące bezpieczeństwa (np. wycieki danych)",
  cancel_subscription_category_1_reason_6_title:
    "Problemy z aplikacją mobilną pracownika (np. zawieszanie się, błędy)",

  cancel_subscription_category_2_title: "Zmiany osobiste/firmowe",
  cancel_subscription_category_2_reason_1_title:
    "Zmiana modelu biznesowego (np. mniejsze zapotrzebowanie na rezerwacje)",
  cancel_subscription_category_2_reason_2_title:
    "Ograniczenia budżetowe lub trudności finansowe",
  cancel_subscription_category_2_reason_3_title:
    "Zbyt duża ilość pracy, by zarządzać systemem",
  cancel_subscription_category_2_reason_4_title:
    "Zamknięcie firmy lub jej ograniczenie",
  cancel_subscription_category_2_reason_5_title:
    "Brak czasu na zarządzanie rezerwacjami",

  cancel_subscription_category_3_title:
    "Czynniki związane z ceną i konkurencją",
  cancel_subscription_category_3_reason_1_title:
    "Tańsze alternatywy dostępne na rynku",
  cancel_subscription_category_3_reason_2_title:
    "Wzrost cen lub zmiana modelu rozliczeń",

  cancel_subscription_category_4_title: "Problemy z doświadczeniem użytkownika",
  cancel_subscription_category_4_reason_1_title:
    "Trudności w poruszaniu się po systemie",
  cancel_subscription_category_4_reason_2_title: "Brak wymaganych funkcji",
  cancel_subscription_category_4_reason_3_title:
    "Zbyt skomplikowane dla Twojego zespołu lub firmy",
  cancel_subscription_category_4_reason_4_title:
    "Wolna lub niepomocna obsługa klienta",
  cancel_subscription_category_4_reason_5_title:
    "Ograniczone opcje personalizacji",
  cancel_subscription_category_4_reason_6_title:
    "Trudny proces konfiguracji lub wdrożenia",

  cancel_subscription_category_5_title: "Czynniki zewnętrzne i rynkowe",
  cancel_subscription_category_5_reason_1_title:
    "Zmiany w trendach rynkowych (np. przejście na rezerwacje przez media społecznościowe)",
  cancel_subscription_category_5_reason_2_title:
    "Kryzys gospodarczy lub spowolnienie",
  cancel_subscription_category_5_reason_3_title: "Zmiany w przepisach prawnych",

  cancel_subscription_category_6_title: "Inne",
  cancel_subscription_category_6_reason_1_title:
    "Powód niewymieniony w pozostałych kategoriach",
  cancel_subscription_category_6_reason_2_title: "Nie chcę podawać powodu",
  cancel_plan_and_delete_data: "Anuluj i usuń dane",
  cancel_plan_do_nothing: "Nic nie rób",
  cancel_plan_and_keep_data_confirmation_label:
    "Czy na pewno chcesz anulować subskrypcję z opcją zachowania danych?",
  cancel_plan_and_keep_data_confirmation_info:
    "Subskrypcja zostanie anulowana z końcem już opłaconego okresu rozliczeniowego. Dane będą bezpiecznie przechowywane na naszych serwerach i mogą zostać przywrócone w dowolnym momencie po reaktywacji subskrypcji.",
  scheduled_cancel_keeps_data_info:
    "Twój plan zostanie anulowany i przejdzie w tryb zachowania danych",
  no_just_checking_title: "Nie, tylko sprawdzam",
  payment_deadline_before_start_variable:
    "Czas na opłacenie rezerwacji przed rozpoczęciem każdej z rezerwacji cyklicznej",
  send_payment_reminder_before_start_variable:
    "Czas wysyłanego powiadomienia o wymaganej płatności przed rezerwacją",
  variable_service_reschedule_deadline_before_start:
    "Termin zmiany rezerwacji przed jej rozpoczęciem",
  variable_service_cancel_deadline_before_start:
    "Termin anulowania rezerwacji przed jej rozpoczęciem",
  variable_customer_private_notes: "Prywatne notatki klienta",
  booking_awaiting_payment_full_description:
    "Pełna informacja o wymaganej płatności",
  booking_awaiting_payment_full_description_example:
    "Brak płatności w ciągu 30 min spowoduje anulowanie rezerwacji. Kliknij poniżej, aby przejść do rezerwacji i dokonać płatności.",
  recurring_meeting_in_the_past_warning:
    'Nie można utworzyć spotkania cyklicznego z datami rozpoczęcia w przeszłości. Wybierz datę początkową w przyszłości lub odznacz opcję „Powtarzaj cyklicznie".',
  // Booking overlaps dialog
  booking_overlaps_dialog_title: "Wykryto konflikt w kalendarzu",
  booking_overlaps_dialog_message:
    "Podczas weryfikacji dostępności wykryliśmy, że wybrany termin koliduje z istniejącymi rezerwacjami lub blokadami. Szczegóły konfliktu:",
  booking_overlaps_count: "Liczba kolidujących rezerwacji",
  unavailable_slot_overlaps_count: "Liczba kolidujących blokad",
  booking_overlaps_dialog_question: "Czy mimo to chcesz kontynuować?",
  selected_date: "Wybrana data",
  single_booking: "Rezerwacja pojedyncza",
  external_api_service_not_enabled_error:
    "Niestety, funkcja API nie jest dostępna dla tego konta.",
  service_not_available_at_selected_time:
    "Usługa nie jest dostępna w wybranym czasie.",
  offline_mode: "Jesteś offline",
  offline_description: "Aplikacja wymaga połączenia z internetem do działania.",
  retry: "Spróbuj ponownie",
  checking_connection: "Sprawdzanie połączenia...",
  waiting_for_connection: "Oczekiwanie na połączenie",
  "2fa_verify_title": "Uwierzytelnianie dwuskładnikowe",
  "2fa_verify_description":
    "Wprowadź swój 6-cyfrowy kod z aplikacji uwierzytelniającej lub użyj kodu odzyskiwania:",
  "2fa_recovery_code_label": "Kod odzyskiwania",
  "2fa_use_recovery_code": "Użyj kodu odzyskiwania",
  "2fa_use_app_code": "Użyj kodu z aplikacji",
  "2fa_verify_incorrect_error": "Kod 2FA jest nieprawidłowy. Spróbuj ponownie.",
  "2fa_session_expired_error": "Twoja sesja 2FA wygasła. Zaloguj się ponownie.",
  "2fa_verification_cancelled":
    "Uwierzytelnianie dwuskładnikowe zostało anulowane. Spróbuj ponownie.",
  enable_2fa: "Włącz 2FA",
  enable_2fa_title: "Włącz weryfikację 2-etapową",
  disable_2fa: "Wyłącz 2FA",
  disable_2fa_title: "Wyłącz weryfikację 2-etapową",
  "2fa_manual_setup": "Nie możesz zeskanować? Wprowadź ten kod ręcznie:",
  "2fa_recovery_codes_title": "Kody odzyskiwania",
  "2fa_download_codes": "Pobierz kody",
  "2fa_disable_description":
    "Zamierzasz wyłączyć weryfikację 2-etapową. To sprawi, że Twoje konto będzie mniej bezpieczne.",
  "2fa_disable_warning":
    "Wyłączenie weryfikacji 2-etapowej zmniejszy bezpieczeństwo Twojego konta.",
  "2fa_verify_to_disable": "Zweryfikuj swoją tożsamość",
  "2fa_verify_to_disable_description":
    "Wprowadź kod z aplikacji uwierzytelniającej lub użyj kodu odzyskiwania, aby wyłączyć weryfikację 2-etapową.",
  warning: "Ostrzeżenie",
  current_password: "Aktualne hasło",
  incorrect_password: "Nieprawidłowe hasło. Spróbuj ponownie.",
  "2fa_setup_failed": "Nie udało się skonfigurować 2FA",
  "2fa_activation_failed": "Nie udało się aktywować 2FA",
  "2fa_verification_code": "Kod weryfikacyjny",
  "2fa_disabled_success": "2FA zostało pomyślnie wyłączone",
  "2fa_disable_failed": "Nie udało się wyłączyć 2FA",
  "2fa_step_1_password_title": "Wprowadź hasło",
  "2fa_step_1_scan_title": "Zeskanuj kod QR",
  "2fa_step_2_verify_title": "Zweryfikuj konfigurację",
  "2fa_authenticator_apps_required": "Wymagana aplikacja uwierzytelniająca",
  "2fa_setup_secure_subtitle":
    "Wybierz i zainstaluj bezpieczną aplikację 2FA, aby zabezpieczyć swoje konto",
  "2fa_apps_installation_note":
    "Zainstaluj jedną z tych aplikacji na telefonie przed kontynuowaniem konfiguracji.",
  "2fa_scan_with_app": "Zeskanuj ten kod QR aplikacją uwierzytelniającą",
  "2fa_enter_code_from_app":
    "Wprowadź 6-cyfrowy kod z aplikacji uwierzytelniającej",
  "2fa_recovery_codes_warning":
    "Przechowuj te kody w bezpiecznym miejscu. Każdy kod może być użyty tylko raz.",
  "2fa_enter_password_to_continue":
    "Wprowadź obecne hasło, aby wygenerować unikalny kod QR",
  "2fa_enter_password_to_disable":
    "Wprowadź obecne hasło, aby potwierdzić wyłączenie 2FA",
  "2fa_disable_verification_description":
    "Wprowadź obecne hasło i kod z aplikacji uwierzytelniającej lub użyj kodu odzyskiwania, aby wyłączyć weryfikację 2-etapową.",
  "2fa_recovery_codes_description":
    "Te kody zapasowe umożliwiają dostęp do konta w przypadku zgubienia aplikacji uwierzytelniającej. Każdy kod może być użyty tylko raz, przechowuj je w bezpiecznym miejscu.",
  security_settings: "Ustawienia bezpieczeństwa",
  security_settings_description:
    "Zarządzaj ustawieniami bezpieczeństwa konta i metodami uwierzytelniania.",
  "2fa_security_title": "Weryfikacja 2-etapowa",
  "2fa_security_description":
    "Dodaj dodatkową warstwę bezpieczeństwa do konta dzięki weryfikacji 2-etapowej.",
  reset_password_description:
    "Wyślij link do resetowania hasła na swój adres e-mail.",
  "2fa_enabled_success": "2FA zostało pomyślnie włączone",
  linkedin: "LinkedIn",
  profile_company_social_media_linkedin_label_input: "Link do profilu LinkedIn",
  logs_diff_linkedin: "Link do profilu LinkedIn",
  tiktok: "TikTok",
  profile_company_social_media_tiktok_label_input: "Link do profilu TikTok",
  logs_diff_tiktok: "Link do profilu TikTok",
  wb_linkedin: "Adres URL - LinkedIn",
  wb_tiktok: "Adres URL - TikTok",
  // Chatwoot package
  plugins_calendesk_chat_cd_base_standard_name: "Calendesk Chat",
  plugins_calendesk_chat_cd_base_standard_description:
    "Ulepsz komunikację z klientami dzięki Calendesk Chat. Zapewniaj wsparcie w czasie rzeczywistym, odpowiadaj na pytania i angażuj się w kontakt z klientami bezpośrednio ze strony rezerwacji. Idealne dla firm, które chcą budować silniejsze relacje z klientami.",
  plugins_calendesk_chat_cd_base_pro_name: "Calendesk Chat",
  plugins_calendesk_chat_cd_base_pro_description:
    "Ulepsz komunikację z klientami dzięki Calendesk Chat. Zapewniaj wsparcie w czasie rzeczywistym, odpowiadaj na pytania i angażuj się w kontakt z klientami bezpośrednio ze strony rezerwacji. Idealne dla firm, które chcą budować silniejsze relacje z klientami.",
  number_of_agents: "Liczba agentów",
  agents_plural: "agentów",
  // Chatwoot integration
  integrations_category_customer_support: "Obsługa klienta",
  chatwoot_title: "Calendesk Chat",
  chatwoot_description:
    "Zarządzaj wsparciem na czacie. Uzyskaj dostęp do panelu, konfiguruj agentów i przeglądaj rozmowy.",
  chatwoot_package_not_active:
    "Pakiet Calendesk Chat nie jest aktywny. Aktywuj go w ustawieniach subskrypcji.",
  chatwoot_setup_title: "Skonfiguruj obsługę czatu",
  chatwoot_setup_info:
    'Calendesk Chat to osobna aplikacja dostępna na <a href="https://chat.calendesk.com" target="_blank">chat.calendesk.com</a>, gdzie będziesz zarządzać rozmowami z klientami.',
  chatwoot_setup_sso_warning:
    "Wszyscy administratorzy Calendesk z dostępem do integracji będą mogli logować się do panelu czatu.",
  chatwoot_setup_next_steps_title: "Po konfiguracji:",
  chatwoot_setup_next_step_1:
    'Konto czatu zostanie utworzone na <a href="https://chat.calendesk.com" target="_blank">chat.calendesk.com</a>',
  chatwoot_setup_next_step_2:
    "Administratorzy będą mogli zalogować się do panelu czatu jednym kliknięciem z menu Calendesk",
  chatwoot_setup_next_step_3:
    "Będziesz mógł dodać widget czatu do strony rezerwacji - kod do osadzenia znajdziesz w panelu czatu",
  chatwoot_company_section_title: "Dane firmy",
  chatwoot_admin_section_title: "Administrator czatu",
  chatwoot_business_name: "Nazwa firmy",
  chatwoot_business_name_hint:
    "Widoczna dla klientów w oknie czatu i powiadomieniach",
  chatwoot_admin_name: "Imię i nazwisko",
  chatwoot_admin_email: "E-mail",
  chatwoot_support_email: "E-mail obsługi klienta",
  chatwoot_support_email_placeholder: "np. kontakt@twojafirma.pl",
  chatwoot_support_email_hint:
    "Klienci zobaczą ten adres jako nadawcę odpowiedzi e-mail od Twojego zespołu",
  chatwoot_start_integration: "Skonfiguruj",
  chatwoot_integration_active:
    "Calendesk Chat jest aktywny i gotowy do użycia.",
  chatwoot_dashboard_info:
    'Zarządzaj rozmowami, agentami i ustawieniami w panelu czatu na <a href="https://chat.calendesk.com" target="_blank">chat.calendesk.com</a>.',
  chatwoot_sso_warning:
    "Wszyscy administratorzy Calendesk z dostępem do integracji mogą logować się do panelu czatu jednym kliknięciem.",
  chatwoot_open_dashboard: "Otwórz panel",
  chatwoot_agent_limit: "Miejsca dla agentów",
  chatwoot_buy_more_agents: "Potrzebujesz więcej agentów? Zmień pakiet",
  chatwoot_integration_success:
    "Calendesk Chat został pomyślnie skonfigurowany!",
  chatwoot_integration_error:
    "Nie udało się skonfigurować Calendesk Chat. Spróbuj ponownie lub skontaktuj się z pomocą techniczną.",
  chatwoot_sso_error:
    "Nie udało się otworzyć panelu czatu. Spróbuj ponownie lub skontaktuj się z pomocą techniczną.",
  chatwoot_suspend_button: "Zawieś",
  chatwoot_suspend_title: "Zawieś Calendesk Chat",
  chatwoot_suspend_warning:
    "Zawieszenie spowoduje dezaktywację wtyczki czatu na stronie WWW po stronie klientów końcowych, <strong>jednak nie wpływa na aktywność pakietu ani na związane z nim opłaty</strong>.<br><br>Aby zrezygnować z pakietu, przejdź do zakładki <strong>Rozliczenia → Subskrypcja</strong> i wybierz opcję <strong>Wyłącz</strong>.",
  chatwoot_suspend_confirm: "Zawieś",
  chatwoot_suspend_success: "Calendesk Chat został zawieszony.",
  chatwoot_suspend_error:
    "Nie udało się zawiesić Calendesk Chat. Spróbuj ponownie lub skontaktuj się z pomocą techniczną.",
  chatwoot_suspended_info:
    "Twoje konto Calendesk Chat jest obecnie zawieszone.",
  chatwoot_suspended_data_preserved:
    "Wszystkie Twoje rozmowy i ustawienia są zachowane i zostaną przywrócone po reaktywacji.",
  chatwoot_reactivate_button: "Reaktywuj",
  chatwoot_reactivation_success: "Calendesk Chat został reaktywowany!",
  chatwoot_reactivation_error:
    "Nie udało się reaktywować Calendesk Chat. Spróbuj ponownie lub skontaktuj się z pomocą techniczną.",
  chatwoot_suspended_tooltip: "Zawieszony - kliknij, aby reaktywować",
  chatwoot_agent_limit_exceeded:
    "Masz @{current} agentów, ale Twój pakiet pozwala tylko na @{limit}.",
  chatwoot_agent_limit_contact_support:
    "Aby reaktywować Calendesk Chat, skontaktuj się z naszym zespołem wsparcia. Pomożemy dostosować liczbę agentów do limitu pakietu.",
  contact_support: "Skontaktuj się z pomocą",
  chatwoot_min_agents_info:
    "Wymagana minimalna liczba agentów: @{count} (na podstawie aktualnej konfiguracji Calendesk Chat).",
  chatwoot_close_confirm_title: "Zamknąć formularz?",
  chatwoot_close_confirm_warning:
    "Wprowadzone dane nie zostały zapisane i zostaną utracone.",
  chatwoot_close_confirm_yes: "Zamknij",
  chatwoot_close_confirm_no: "Wróć do formularza",

  dialog_close_confirm_title: "Zamknąć?",
  dialog_close_confirm_warning: "Niezapisane zmiany zostaną utracone.",
  dialog_close_confirm_yes: "Zamknij",
  dialog_close_confirm_no: "Anuluj",

  // Reports
  reports: "Raporty",
  reports_granularity: "Grupuj wg",
  reports_revenue: "Przychody i płatności",
  reports_bookings: "Rezerwacje",
  reports_team: "Mój zespół",
  reports_customers: "Klienci i sprzedaż",
  reports_clients: "Klienci",
  reports_subscriptions: "Subskrypcje",
  reports_products: "Produkty",
  reports_tab_revenue: "Przychody",
  date_range: "Zakres dat",
  vs_previous_period: "vs poprzedni okres",
  reports_revenue_timeline: "Przychody w czasie",
  reports_top_services: "Najlepsze usługi",
  reports_top_products: "Najlepsze produkty",
  reports_payment_providers: "Metody płatności",
  reports_payment_methods_count: "Transakcje wg metody płatności",
  reports_payment_methods_value: "Przychody wg metody płatności",
  reports_payment_timeline: "Płatności w czasie",
  reports_bookings_timeline: "Rezerwacje w czasie",
  reports_by_service: "Wg usługi",
  reports_by_employee: "Wg pracownika",
  reports_by_delivery_type: "Wg typu realizacji",
  reports_cancellation_reasons: "Przyczyny anulowania",
  reports_by_day: "Wg dnia tygodnia",
  reports_by_hour: "Wg godziny",
  reports_heatmap: "Mapa cieplna rezerwacji",
  reports_employee_performance: "Wyniki zespołu",
  reports_service_ranking: "Ranking usług",
  reports_by_category: "Wg kategorii",
  reports_locations: "Lokalizacje",
  reports_customer_segments: "Zaangażowanie klientów",
  reports_top_customers: "Najlepsi klienci",
  reports_product_revenue_timeline: "Przychody z produktów w czasie",
  reports_booking_revenue_timeline: "Przychody z rezerwacji w czasie",
  reports_top_subscriptions: "Najlepsze subskrypcje",
  reports_subscription_timeline: "Nowe subskrypcje w czasie",
  reports_subscription_revenue_timeline: "Przychody z subskrypcji w czasie",
  reports_revenue_forecast: "Prognoza przychodów",
  reports_bookings_forecast: "Prognoza rezerwacji",

  // Section headers
  reports_section_key_metrics: "Kluczowe wskaźniki",
  reports_section_key_metrics_tooltip:
    "<b>Kluczowe wskaźniki</b><br><br>Najważniejsze metryki Twojego biznesu w wybranym okresie. Strzałki pokazują zmiany w porównaniu z poprzednim okresem o tej samej długości.",
  reports_section_trends: "Trendy",
  reports_section_trends_tooltip:
    "<b>Trendy</b><br><br>Jak zmieniały się Twoje przychody i rezerwacje w wybranym okresie.",
  reports_section_revenue: "Przychody",
  reports_section_revenue_tooltip:
    "<b>Przychody</b><br><br>Łączny przychód ze wszystkich źródeł w wybranym okresie. Liczone są tylko <b>zrealizowane płatności</b>.<br><br>Zawiera:<br>• <b>Podział przychodów</b> — z rezerwacji, subskrypcji i produktów<br>• <b>Śr. wartość rezerwacji</b> i <b>wskaźnik opłacalności</b><br>• <b>Oś czasu przychodów</b> — jak zmieniał się przychód w czasie<br>• <b>Najlepsze usługi, subskrypcje i produkty</b> — uszeregowane wg przychodu<br>• <b>Metody płatności</b> — liczba transakcji i przychód na metodę",
  reports_section_bookings: "Rezerwacje",
  reports_section_bookings_tooltip:
    "<b>Rezerwacje</b><br><br>Statusy rezerwacji, zmiany liczby w czasie oraz podział wg usług i pracowników w wybranym okresie.<br><br>Zawiera:<br>• <b>Podział wg statusów</b> — zatwierdzone, zakończone, anulowane<br>• <b>Oś czasu rezerwacji</b> — zmiany liczby rezerwacji w czasie<br>• <b>Przychody z rezerwacji</b> — jak zmieniały się przychody z rezerwacji w czasie<br>• <b>Wg usługi i pracownika</b> — najczęściej rezerwowane usługi i najbardziej zapracowani pracownicy",
  reports_section_patterns: "Wzorce rezerwacji",
  reports_section_patterns_tooltip:
    "<b>Wzorce rezerwacji</b><br><br>Kiedy Twoi klienci najchętniej rezerwują. Wykorzystaj to do optymalizacji grafiku.<br><br>Zawiera:<br>• <b>Mapa cieplna</b> — najpopularniejsze dni i godziny<br>• <b>Najpopularniejszy dzień</b> — który dzień tygodnia ma najwięcej rezerwacji<br>• <b>Wg godzin</b> — rozkład rezerwacji na poszczególne godziny",
  reports_section_employees: "Mój zespół",
  reports_section_employees_tooltip:
    "<b>Mój zespół</b><br><br>Jak radził sobie każdy członek zespołu w wybranym okresie.<br><br>Zawiera:<br>• <b>Zrealizowane rezerwacje</b> — liczba zakończonych rezerwacji na osobę<br>• <b>Wygenerowany przychód</b> — dochód z ich rezerwacji<br>• <b>Zapełnienie grafiku</b> — ile z dostępnego czasu pracy było zarezerwowane",
  reports_section_services: "Usługi",
  reports_section_services_tooltip:
    "<b>Usługi</b><br><br>Najpopularniejsze usługi i ich przychody w wybranym okresie.<br><br>Zawiera:<br>• <b>Rezerwacje na usługę</b> — liczba zatwierdzonych i zakończonych rezerwacji<br>• <b>Przychód na usługę</b> — wygenerowany dochód",
  reports_section_locations: "Lokalizacje",
  reports_section_locations_tooltip:
    "<b>Lokalizacje</b><br><br>Wyniki wg lokalizacji i typu realizacji w wybranym okresie.",
  reports_section_customers: "Klienci",
  reports_section_customers_tooltip:
    "<b>Klienci</b><br><br>Kto rezerwuje najczęściej, kto wydaje najwięcej i jak zaangażowani są Twoi klienci w wybranym okresie.<br><br>Zawiera:<br>• <b>Nowi klienci</b> — zarejestrowani w wybranym okresie<br>• <b>Aktywni klienci</b> — mieli co najmniej jedną rezerwację<br>• <b>Wykres zaangażowania</b> — nowi, powracający i lojalni stali bywalcy<br>• <b>Najlepsi klienci</b> — z największymi wydatkami w wybranym okresie",
  reports_section_customer_overview: "Klienci",
  reports_section_customer_overview_tooltip:
    "<b>Klienci</b><br><br>Wartości za całą historię — nie zmieniają się po zmianie zakresu dat.",
  reports_section_customer_activity: "Aktywność w okresie",
  reports_section_customer_activity_tooltip:
    "<b>Aktywność w okresie</b><br><br>Jak klienci angażowali się w wybranym okresie — rezerwacje, retencja i preferencje.",
  reports_section_products: "Produkty",
  reports_section_products_tooltip:
    "<b>Produkty</b><br><br>Sprzedaż produktów, przychody w czasie i bestsellery w wybranym okresie.<br><br>Zawiera:<br>• <b>Łączny przychód z produktów</b> w wybranym okresie<br>• <b>Oś czasu przychodów</b> — jak sprzedaż produktów zmieniała się w czasie<br>• <b>Najlepsze produkty</b> — bestsellery według przychodu",
  reports_section_subscriptions: "Subskrypcje",
  reports_section_subscriptions_tooltip:
    "<b>Subskrypcje</b><br><br>Przychody, odnowienia i wykorzystanie planów subskrypcyjnych w wybranym okresie.<br><br>Zawiera:<br>• <b>Aktywne subskrypcje</b> — ilu klientów ma teraz aktywny plan<br>• <b>Przychód</b> — ile zarobiłeś na subskrypcjach w wybranym okresie<br>• <b>Współczynnik odnowień</b> — ilu subskrybentów zapłaciło więcej niż raz (wyższy = klienci wracają)<br>• <b>Nowe subskrypcje</b> — ile nowych subskrypcji rozpoczęto w danym okresie<br>• <b>Przychody z subskrypcji</b> — jak zmieniały się przychody z subskrypcji w czasie<br>• <b>Najlepsze subskrypcje</b> — które plany przynoszą najwięcej pieniędzy<br>• <b>Wykorzystanie</b> — czy subskrybenci faktycznie korzystają z dostępnych rezerwacji?",
  reports_section_payments: "Płatności",
  reports_section_payments_tooltip:
    "<b>Płatności</b><br><br>Dane transakcyjne i podział wg metod płatności w wybranym okresie.<br><br>Zawiera:<br>• <b>Łączna liczba transakcji</b> — liczba zrealizowanych płatności<br>• <b>Wskaźnik opłacalności</b> — procent opłaconych rezerwacji<br>• <b>Wg metody płatności</b> — liczba transakcji i przychód na metodę",
  reports_section_booking_status: "Status rezerwacji",
  reports_section_cancellation_reasons: "Powody anulowania",
  reports_section_peak_hours: "Godziny szczytu",
  reports_section_peak_hours_tooltip:
    "<b>Jak czytać ten wykres:</b><br><br><b>Wiersze</b> = dni tygodnia<br><b>Kolumny</b> = godziny (00:00–23:00)<br><br>Każda komórka pokazuje <b>łączną liczbę</b> zatwierdzonych i zakończonych rezerwacji zaplanowanych w danym dniu o danej godzinie w <b>całym wybranym okresie</b>.<br><br><b>Przykład:</b> Jeśli wybrałeś 3 miesiące, komórka poniedziałek 10:00 pokazuje ile rezerwacji przypadło na dowolny poniedziałek o 10:00 w ciągu tych 3 miesięcy łącznie.<br><br>🟦 Ciemniejszy kolor = więcej rezerwacji",
  reports_section_busiest_day: "Najbardziej pracowity dzień tygodnia",
  stats_monday: "Poniedziałek",
  stats_tuesday: "Wtorek",
  stats_wednesday: "Środa",
  stats_thursday: "Czwartek",
  stats_friday: "Piątek",
  stats_saturday: "Sobota",
  stats_sunday: "Niedziela",
  stats_mon: "Pon",
  stats_tue: "Wt",
  stats_wed: "Śr",
  stats_thu: "Czw",
  stats_fri: "Pt",
  stats_sat: "Sob",
  stats_sun: "Ndz",
  reports_section_delivery_type: "Według sposobu realizacji",
  reports_section_peak_times: "Najpopularniejsze terminy",
  reports_bookings_by_hour: "Rezerwacje wg godziny",
  reports_bookings_by_service: "Najczęściej rezerwowane usługi",
  reports_bookings_by_employee: "Najaktywniejszy zespół",
  reports_booking_lead_time: "Czas wyprzedzenia rezerwacji",
  reports_bookings_by_location: "Rezerwacje wg lokalizacji",

  // Renderer-specific notes
  reports_employee_performance_note:
    'Wypełnienie kalendarza pokazuje "--", jeśli dla danego pracownika nie ustawiono godzin pracy.',
  reports_customer_segments_chart: "Segmenty klientów",
  reports_customer_segments_note:
    "Podział aktywnych klientów na trzy grupy na podstawie historii rezerwacji. Suma trzech grup = aktywni klienci.",
  reports_services_by_category: "Rezerwacje wg kategorii",
  reports_service_ranking_note:
    "Sortowane wg liczby rezerwacji. Kliknij w nagłówek kolumny, aby zmienić sortowanie.",
  reports_mrr_trend: "Nowe subskrypcje",
  reports_subscription_usage: "Wykorzystanie subskrypcji",
  reports_subscription_usage_tooltip:
    "Czy Twoi subskrybenci faktycznie korzystają z rezerwacji zawartych w planach?<br><br>• <b>Wykorzystanie limitu</b> — jeśli plan zawiera 10 rezerwacji, a klient wykorzystał 3, to 30%. To jest średnia ze wszystkich subskrybentów.<br>• <b>Niewykorzystane rezerwacje</b> — łączna liczba rezerwacji z planów, których nikt nie wykorzystał. Duża liczba oznacza, że subskrybenci marnują dostępne rezerwacje.",

  // Stats labels — KPI cards, table columns, chart headers
  // Dashboard
  stats_revenue: "Przychód",
  stats_bookings: "Rezerwacje",
  stats_subscriptions: "Subskrypcje",
  stats_products: "Produkty",
  stats_new_customers: "Nowi klienci",
  stats_cancellation_rate: "Wskaźnik anulacji",
  // Revenue
  stats_avg_booking_value: "Śr. wartość rezerwacji",
  stats_total_revenue: "Łączny przychód",
  stats_from_bookings: "Rezerwacje",
  stats_from_products: "Produkty",
  stats_from_subscriptions: "Subskrypcje",
  // Team
  stats_active_employees: "Aktywni pracownicy",
  stats_team_revenue: "Przychód zespołu",
  stats_schedule_fill_rate: "Wypełnienie kalendarza",
  stats_total_booked_hours: "Łącznie godzin",
  // Bookings
  stats_total_bookings: "Wszystkie rezerwacje",
  stats_approved: "Zatwierdzone",
  stats_done: "Zakończone",
  stats_cancelled: "Anulowane",
  stats_payment: "Oczekujące na płatność",
  stats_status: "Status",
  // Tables — common
  stats_service: "Usługa",
  stats_employee: "Pracownik",
  stats_delivery_type: "Typ realizacji",
  stats_share: "Udział",
  stats_reason: "Powód",
  stats_cancellations: "Anulacje",
  stats_category: "Kategoria",
  stats_location: "Lokalizacja",
  stats_type: "Typ",
  stats_provider: "Metoda",
  stats_transactions: "Transakcje",
  stats_value: "Łącznie",
  stats_product: "Produkt",
  stats_quantity: "Ilość",
  stats_subscription: "Subskrypcja",
  stats_customer: "Klient",
  stats_email: "Email",
  // Employees
  stats_customers_served: "Obsłużeni klienci",
  stats_utilization: "Obłożenie",
  stats_available_hours: "Dostępne godziny",
  stats_booked_hours: "Zarezerwowane godziny",
  // Services
  stats_unique_customers: "Unikalni klienci",
  // Customers
  stats_total_customers: "Wszyscy klienci",
  stats_active_customers: "Aktywni klienci",
  stats_returning_customers: "Powracający klienci",
  stats_retention_rate: "Wskaźnik retencji",
  stats_customer_ltv: "Wartość klienta",
  stats_avg_days_between_visits: "Śr. dni między rezerwacjami",
  stats_preferred_delivery: "Preferowana lokalizacja",
  stats_preferred_payment: "Preferowana płatność",
  stats_total_spent: "Łączne wydatki",
  // Products
  stats_total_sold: "Łącznie sprzedano",
  stats_product_revenue: "Przychód z produktów",
  // Subscriptions
  stats_active_subscriptions: "Aktywne subskrypcje",
  stats_subscription_revenue: "Przychód z subskrypcji",
  stats_renewal_rate: "Wskaźnik odnowień",
  stats_active_users: "Aktywni użytkownicy",
  stats_avg_utilization: "Wykorzystanie limitu rezerwacji",
  stats_booking_limit_usage: "Wykorzystanie limitu rezerwacji",
  stats_unused_booking_slots: "Niewykorzystane rezerwacje",
  stats_unused_bookings: "Niewykorzystane rezerwacje",
  // Payments
  stats_total_transactions: "Wszystkie transakcje",
  stats_total_value: "Łączna wartość",
  stats_booking_payment_rate: "% opłaconych rezerwacji",
  stats_method: "Metoda",
  // Patterns
  stats_day: "Dzień",
  stats_hour: "Godzina",
  stats_busiest_day: "Najbardziej aktywny dzień",
  stats_busiest_hour: "Najbardziej aktywna godzina",
  stats_average_lead_time: "Śr. dni z wyprzedzeniem",
  stats_median_lead_time: "Mediana dni z wyprzedzeniem",
  // Forecast
  stats_month: "Miesiąc",
  stats_projected: "Prognoza",
  stats_low_estimate: "Dolna granica",
  stats_high_estimate: "Górna granica",
  // Chart field names
  stats_period: "Okres",
  stats_count: "Liczba",
  stats_bookings_count: "Rezerwacje",
  stats_name: "Nazwa",

  // KPI tooltips
  stats_cancellation_rate_tooltip:
    "Jak często rezerwacje są anulowane.<br><br><b>Wzór:</b> anulowane ÷ (zatwierdzone + zakończone + anulowane)<br><b>Przykład:</b> 10 rezerwacji, 2 anulowane = <b>20%</b>",
  stats_customer_ltv_tooltip:
    "Ile klient wydał u Ciebie łącznie przez cały okres współpracy — nie tylko w wybranym okresie.",
  stats_utilization_tooltip:
    "Średnie obłożenie grafiku w Twoim zespole. Dla każdego pracownika: zarezerwowane godziny ÷ dostępne godziny.<br><br><b>Dostępne godziny</b> wynikają z <b>Grafiku dostępności</b> pracownika. Dni wolne i wyjątki w grafiku są uwzględniane.<br><br>Przykład: pracownik pracuje pon.–pt., 9:00–17:00 (40 godz./tyg.). Jeśli 30 godzin jest zarezerwowanych, obłożenie wynosi 75%.",
  stats_booking_payment_rate_tooltip:
    "Procent opłaconych rezerwacji spośród wszystkich zaplanowanych w wybranym okresie.<br><br>Liczymy po dacie usługi — rezerwacja utworzona dziś na maj trafia do raportu za maj.",
  stats_renewal_rate_tooltip:
    "Ilu subskrybentów przedłużyło swój plan po pierwszej płatności — to znak zadowolenia klientów.",
  stats_unused_booking_slots_tooltip:
    "Łączna liczba rezerwacji, które subskrybenci mogli zrobić (na podstawie limitów planu), ale tego nie zrobili.<br><br><b>Przykład:</b> 3 subskrybentów ma plan z 10 rezerwacjami/miesiąc. Jeden wykorzystał 7, drugi 3, trzeci 0. To daje 3 + 7 + 10 = <b>20 niewykorzystanych rezerwacji</b>.<br><br>Duża liczba może oznaczać, że limity są za wysokie lub subskrybenci potrzebują przypomnienia o rezerwacji.",
  stats_active_subscriptions_tooltip:
    "Nowe subskrypcje rozpoczęte w wybranym okresie. To <b>nie</b> jest łączna liczba wszystkich aktywnych subskrybentów.",
  stats_avg_utilization_tooltip:
    'Niektóre plany subskrypcyjne zawierają określoną liczbę rezerwacji (np. "10 rezerwacji na miesiąc"). To pokazuje jaki procent tych rezerwacji Twoi subskrybenci faktycznie wykorzystali.<br><br><b>Przykład:</b> Klient kupuje plan z 10 rezerwacjami/miesiąc, ale umawia się tylko 3 razy → to 30% wykorzystania.<br><br>Niski procent oznacza, że subskrybenci nie wykorzystują w pełni tego, za co zapłacili. Uwzględnia tylko zatwierdzone i zakończone rezerwacje.',
  // Dashboard KPIs
  stats_new_customers_tooltip:
    "Nowi klienci, którzy zarejestrowali się w wybranym okresie. Na podstawie daty utworzenia konta.",
  // Revenue section KPIs
  stats_total_revenue_tooltip:
    "Łączny przychód w wybranym okresie z:<br>• rezerwacji<br>• subskrypcji<br>• sprzedaży produktów<br><br>Liczone są tylko <b>zrealizowane płatności</b>, na podstawie daty płatności.",
  stats_from_bookings_tooltip:
    "Przychody z płatności za rezerwacje w wybranym okresie. Liczone są tylko <b>zrealizowane płatności</b>.",
  stats_from_products_tooltip:
    "Przychody ze sprzedaży jednorazowych produktów w wybranym okresie.",
  stats_from_subscriptions_tooltip:
    "Przychody z płatności za subskrypcje w wybranym okresie.",
  // Booking status KPIs
  stats_total_bookings_tooltip:
    "Łączna liczba rezerwacji ze statusem <b>zatwierdzone</b> i <b>zakończone</b> w wybranym okresie. Rezerwacje <b>anulowane</b> i <b>oczekujące na płatność</b> nie są liczone.",
  stats_approved_tooltip:
    "Liczba rezerwacji ze statusem <b>zatwierdzone</b> w wybranym okresie.",
  stats_done_tooltip:
    "Liczba rezerwacji ze statusem <b>zakończone</b> w wybranym okresie.",
  stats_cancelled_tooltip:
    "Rezerwacje <b>anulowane</b> w wybranym okresie — przez klienta lub przez Ciebie.",
  // Team summary KPIs
  stats_active_employees_tooltip:
    "Pracownicy, którzy mieli co najmniej jedną zatwierdzoną lub zakończoną rezerwację w wybranym okresie.",
  stats_team_revenue_tooltip:
    "Łączny przychód z rezerwacji wszystkich pracowników w wybranym okresie. Liczone tylko zrealizowane płatności.",
  stats_schedule_fill_rate_tooltip:
    'Ile dostępnego czasu twojego zespołu jest wypełnione rezerwacjami.<br><br><b>Jak to liczymy:</b><br>1. Dla każdego pracownika sprawdzamy każdy dzień w wybranym okresie<br>2. Na każdy dzień sprawdzamy grafik — nadpisania dat (dni wolne, specjalne godziny) mają pierwszeństwo przed grafikiem tygodniowym<br>3. Sumujemy godziny zarezerwowane (zatwierdzone i zakończone rezerwacje)<br>4. Wypełnienie = zarezerwowane godziny ÷ dostępne godziny<br>5. Uśredniamy wynik dla wszystkich pracowników<br><br><b>Przykład:</b> Anna ma 40h dostępnych, 20h zarezerwowanych → 50%. Marek ma 40h dostępnych, 30h zarezerwowanych → 75%. Średnia = <b>62,5%</b><br><br>Pracownicy bez ustawionego grafiku są pomijani. "--" oznacza, że nikt nie ma grafiku.',
  stats_total_booked_hours_tooltip:
    "Łączna liczba godzin spędzonych na rezerwacjach przez cały zespół w wybranym okresie.",
  // Employee KPIs
  stats_customers_served_tooltip:
    "Liczba różnych klientów, z którymi ten pracownik pracował w wybranym okresie.",
  stats_available_hours_tooltip:
    'Ile godzin ten pracownik mógł przepracować w wybranym okresie, na podstawie jego grafiku.<br><br><b>Jak to liczymy:</b> sprawdzamy każdy dzień w wybranym okresie. Jeśli na dany dzień jest nadpisanie (np. dzień wolny), używamy go. W przeciwnym razie używamy standardowego grafiku tygodniowego.<br><br><b>Przykład:</b> pon.–pt. 9:00–17:00. Okres = pon. do niedz. → 5 dni roboczych × 8h = <b>40h</b>. Jeśli środa jest oznaczona jako dzień wolny, to 4 × 8h = <b>32h</b>.<br><br>"--" oznacza brak ustawionego grafiku.',
  stats_booked_hours_tooltip:
    "Godziny pracy faktycznie wypełnione rezerwacjami w wybranym okresie.",
  // Customer KPIs
  stats_total_tooltip:
    "Łączna liczba klientów zarejestrowanych u Ciebie — przez cały czas, nie tylko w wybranym okresie.",
  stats_new_tooltip:
    "Klienci, którzy zarezerwowali po raz pierwszy w wybranym okresie — wcześniej nie mieli żadnych rezerwacji.",
  stats_active_tooltip:
    "Klienci, którzy mieli co najmniej jedną rezerwację ze statusem <b>zatwierdzone</b> lub <b>zakończone</b> w wybranym okresie.",
  stats_returning_tooltip:
    "Klienci, którzy mieli rezerwację przed wybranym okresem i powrócili w jego trakcie.",
  stats_ltv_tooltip:
    "Średnia łączna kwota wydana przez klienta od daty rejestracji — przez cały czas, nie tylko w wybranym okresie.",
  stats_preferred_delivery_type_tooltip:
    "Najczęściej wybierany typ lokalizacji przez Twoich klientów — np. Google Meet, adres, telefon lub Microsoft Teams.",
  stats_total_customers_tooltip:
    "Łączna liczba zarejestrowanych klientów — z całej historii, nie tylko z wybranego okresu.",
  stats_preferred_payment_method_tooltip:
    "Metoda płatności najczęściej używana przez Twoich klientów przy opłacaniu rezerwacji.",
  stats_active_customers_tooltip:
    "Klienci, którzy mieli co najmniej jedną rezerwację w wybranym okresie.",
  stats_returning_customers_tooltip:
    "Klienci, którzy mieli rezerwacje przed wybranym okresem i wrócili w jego trakcie. Przy wybranym <b>Od początku</b> wynik wyniesie 0.",
  stats_retention_rate_tooltip:
    "Jaki procent aktywnych klientów rezerwował u Ciebie już wcześniej.<br><br><b>Wzór:</b> powracający ÷ aktywni × 100<br><b>Przykład:</b> 10 aktywnych, 6 powracających = <b>60%</b>",
  stats_avg_days_between_visits_tooltip:
    "Średnia liczba dni między rezerwacjami klientów, którzy przychodzą więcej niż raz.",
  // Product KPIs
  stats_total_sold_tooltip: "Liczba sprzedanych produktów w wybranym okresie.",
  stats_product_revenue_tooltip:
    "Łączne przychody ze sprzedaży produktów w wybranym okresie.",
  stats_subscription_revenue_tooltip:
    "Łączne przychody z płatności za subskrypcje w wybranym okresie.",
  stats_active_users_tooltip:
    "Subskrybenci, którzy dokonali co najmniej jednej rezerwacji w ramach swojej subskrypcji w wybranym okresie.",
  // Payment KPIs
  stats_total_value_tooltip:
    "Suma wszystkich <b>zrealizowanych</b> transakcji płatniczych (rezerwacje, produkty i subskrypcje) w wybranym okresie.",
  // Pattern KPIs
  stats_busiest_day_tooltip:
    "Dzień tygodnia z największą liczbą rezerwacji w wybranym okresie.",
  stats_busiest_hour_tooltip:
    "Godzina dnia z największą liczbą rezerwacji w wybranym okresie.",
  // Widget-specific tooltips (shared with dashboard widgets)
  stats_avg_booking_value_tooltip:
    "Średnia kwota zapłacona za rezerwację w wybranym okresie.<br><br><b>Wzór:</b> przychód z rezerwacji ÷ liczba opłaconych rezerwacji",
  stats_mrr_tooltip:
    "Łączny przychód z płatności za subskrypcje w wybranym okresie. Pokazuje sumę wszystkich opłaconych transakcji subskrypcyjnych, nie znormalizowaną stawkę miesięczną.",
  stats_top_clients_tooltip:
    "Klienci generujący największy przychód w wybranym okresie, posortowani malejąco.",
  stats_top_service_tooltip:
    "Usługa z największą liczbą rezerwacji w wybranym okresie.",
  stats_bookings_timeline_tooltip:
    "Jak zmieniała się liczba rezerwacji w wybranym okresie. Uwzględnia rezerwacje ze statusem <b>zatwierdzone</b> i <b>zakończone</b>.<br><br><b>Prognoza:</b> linia przerywana na nadchodzące okresy — rezerwacje, które są już zaplanowane (<b>zatwierdzone</b> lub <b>oczekujące na płatność</b>).",
  stats_peak_hours_heatmap_tooltip:
    "Mapa cieplna pokazująca, kiedy najczęściej odbywają się rezerwacje — wg dnia tygodnia i godziny. Ciemniejsze komórki = więcej rezerwacji.",
  stats_booking_revenue_tooltip:
    "Przychód wyłącznie z płatności za rezerwacje w wybranym okresie — bez sprzedaży produktów i subskrypcji.",
  stats_total_transactions_tooltip:
    "Łączna liczba transakcji płatniczych przetworzonych w wybranym okresie ze wszystkich źródeł.",

  stats_revenue_timeline_tooltip:
    "Przychody w podziale na źródła — rezerwacje, subskrypcje i produkty. Tylko zrealizowane płatności, na podstawie daty płatności. Kliknij pozycję w legendzie, żeby pokazać lub ukryć linię.<br><br><b>Prognoza</b>: linie przerywane pokazują prognozowane przychody — z rezerwacji już opłaconych lub oczekujących na płatność oraz szacowany przychód z aktywnych subskrypcji.",
  stats_revenue_top_services_table_tooltip:
    "Usługi uszeregowane wg przychodu w wybranym okresie.",
  stats_revenue_top_products_table_tooltip:
    "Produkty uszeregowane wg przychodu w wybranym okresie.",
  stats_payment_providers_chart_tooltip:
    "Liczba <b>zrealizowanych</b> transakcji wg metod płatności (np. Stripe, gotówka, karta) w wybranym okresie.",
  stats_payment_methods_count_chart_tooltip:
    "Ile transakcji zostało przetworzonych przez każdą metodę płatności w wybranym okresie.",
  stats_payment_methods_value_chart_tooltip:
    "Łączny przychód z każdej metody płatności w wybranym okresie.",
  stats_booking_status_chart_tooltip:
    "Rezerwacje wg statusu — <b>zatwierdzone</b>, <b>zakończone</b>, <b>anulowane</b> i <b>oczekujące na płatność</b> — w wybranym okresie.",
  stats_cancellation_reasons_chart_tooltip:
    "Najczęstsze powody anulowania rezerwacji w wybranym okresie.",
  stats_busiest_day_chart_tooltip:
    "Które dni tygodnia mają najwięcej rezerwacji w wybranym okresie.",
  stats_delivery_type_chart_tooltip:
    "Jak rezerwacje rozkładają się między typy realizacji — osobiście, online, telefonicznie itp. — w wybranym okresie.",
  stats_peak_times_tooltip:
    "Dzień i godzina z największą liczbą rezerwacji ze statusem <b>zatwierdzone</b> i <b>zakończone</b> w wybranym okresie.",
  stats_bookings_by_hour_tooltip:
    "Jak rezerwacje rozkładają się na poszczególne godziny dnia w wybranym okresie.",
  stats_bookings_by_service_tooltip:
    "Które usługi były najczęściej rezerwowane w wybranym okresie.",
  stats_bookings_by_employee_tooltip:
    "Którzy członkowie zespołu obsłużyli najwięcej rezerwacji w wybranym okresie.",
  stats_booking_lead_time_tooltip:
    "Z jakim wyprzedzeniem klienci rezerwują — liczba dni między złożeniem rezerwacji a jej terminem.",
  stats_bookings_by_location_tooltip:
    "Jak rezerwacje rozkładają się między lokalizacjami w wybranym okresie.",
  stats_average_lead_time_tooltip:
    "Średnia liczba dni między utworzeniem rezerwacji a jej terminem.",
  stats_median_lead_time_tooltip:
    "Mediana liczby dni między utworzeniem rezerwacji a jej terminem. Mniej wrażliwa na wartości skrajne niż średnia.",
  // Forecast KPIs
  stats_low_estimate_tooltip:
    "Dolna granica prognozy — Twoje wyniki mogą kształtować się na tym poziomie, jeśli kolejny okres będzie spokojniejszy niż zwykle.",
  stats_high_estimate_tooltip:
    "Górna granica prognozy — optymistyczny scenariusz na kolejny okres.",
  // Widget-specific tooltips (shared with dashboard widgets)
  stats_booking_status_tooltip:
    "Podział rezerwacji wg statusu — <b>zatwierdzone</b>, <b>zakończone</b> i <b>anulowane</b> — w wybranym okresie.",
  stats_customer_segments_chart_tooltip:
    "Jak zaangażowani są Twoi aktywni klienci w wybranym okresie:<br>• <b>Pierwsza wizyta</b> — pierwsza rezerwacja w historii<br>• <b>Wrócili</b> — mieli wcześniej rezerwacje, odwiedzili raz w tym okresie<br>• <b>Lojalni</b> — mieli wcześniej rezerwacje i przyszli 2+ razy w tym okresie",
  stats_top_customers_table_tooltip:
    "Łączny wydatek w wybranym okresie — obejmuje wszystkie płatności klienta: za rezerwacje, subskrypcje i produkty.",
  stats_employee_table_tooltip:
    "Przegląd wyników pracowników — rezerwacje, godziny i obłożenie w wybranym okresie.",
  stats_service_table_tooltip:
    "Przegląd wyników usług — rezerwacje i przychody w wybranym okresie.",
  stats_services_by_category_tooltip:
    "Liczba zatwierdzonych i zakończonych rezerwacji dla każdej kategorii usług w wybranym okresie.",
  stats_booking_revenue_timeline_tooltip:
    "Jak zmieniały się przychody z rezerwacji w wybranym okresie.",
  stats_subscription_revenue_timeline_tooltip:
    "Jak zmieniały się przychody z subskrypcji w wybranym okresie.",
  stats_product_revenue_timeline_tooltip:
    "Jak zmieniały się przychody z produktów w wybranym okresie.",
  stats_subscription_timeline_tooltip:
    "Liczba nowych subskrypcji rozpoczętych w danym okresie.",
  stats_top_subscriptions_table_tooltip:
    "Plany subskrypcyjne uszeregowane wg przychodu w wybranym okresie.",
  stats_top_products_table_tooltip:
    "Produkty uszeregowane wg przychodu w wybranym okresie.",
  stats_not_assigned: "Nieprzypisane",
  stats_low: "Niska",
  stats_medium: "Średnia",
  stats_high: "Wysoka",
  stats_insufficient: "Niewystarczające dane",
  stats_type_name: "Typ dostawy",
  stats_new_subscriptions: "Nowe subskrypcje",
  stats_new: "Nowi",
  stats_returning: "Powracający",
  stats_first_time: "Pierwsza wizyta",
  stats_first_time_tooltip:
    "Klienci bez rezerwacji przed wybranym okresem — to ich pierwsza wizyta.",
  stats_came_back: "Wrócili",
  stats_came_back_tooltip:
    "Klienci, którzy mieli rezerwacje wcześniej i zarezerwowali raz w tym okresie.",
  stats_loyal: "Lojalni",
  stats_loyal_tooltip:
    "Klienci, którzy mieli rezerwacje wcześniej i zarezerwowali 2+ razy w tym okresie.",
  stats_staff: "Pracownik",
  stats_payment_timeout: "Brak płatności",
  stats_calendar_sync: "Synchronizacja kalendarza",
  stats_in_person: "Adres",
  stats_phone: "Telefon",
  stats_other: "Inna",
  stats_stripe: "Stripe",
  stats_cash: "Gotówka",
  stats_card: "Karta",
  stats_transfer: "Przelew",
  stats_google_meet: "Google Meet",
  stats_zoom: "Zoom",
  stats_microsoft_teams: "Microsoft Teams",
  stats_skype: "Skype",
  stats_whatsapp: "WhatsApp",
  stats_client: "Klient",
  stats_no_payment: "Brak płatności",
  stats_external: "Synchronizacja kalendarza",
  bulk_operation_progress: "Przetwarzanie: @{done} z @{total}",
  bulk_operation_counting: "Liczenie rekordów...",
  bulk_action_delete_bookings: "Usuwanie rezerwacji",
  bulk_action_delete_users: "Usuwanie użytkowników",
  bulk_action_update_users: "Aktualizowanie użytkowników",
  bulk_action_export_users: "Eksportowanie użytkowników",
  bulk_action_add_to_group: "Dodawanie do grup",
  bulk_action_remove_from_group: "Usuwanie z grup",
  bulk_action_send_notification: "Wysyłanie powiadomień",
  bulk_action_update_bookings: "Aktualizowanie rezerwacji",
  bulk_action_export_events: "Eksportowanie wydarzeń",
  bulk_action_update_employees: "Aktualizowanie pracowników",
  bulk_action_delete_employees: "Usuwanie pracowników",
  bulk_action_export_employees: "Eksportowanie pracowników",
  bulk_notification_sending: "Wysyłanie powiadomień...",
  bulk_export_generating: "Generowanie pliku...",
  bulk_export_sent_to_email: "Plik wysłany na Twój e-mail",
  bulk_export_sent_to_email_with_errors:
    "Plik wysłany na Twój e-mail. Przetworzone: @{processed}, błędy: @{failed}.",
  download_csv: "Pobierz CSV",
  selection_all_on_page: "Zaznaczono @{amount} pozycji na tej stronie.",
  selection_select_all_records: "Zaznacz @{total} pozycji ze wszystkich stron",
  selection_all_records_selected:
    "Zaznaczono @{total} pozycji ze wszystkich stron.",

  // Dashboard widgets
  your_overview: "Twój przegląd",
  add_widget: "Dodaj widget",
  widget_group_revenue: "Przychody",
  widget_group_bookings: "Rezerwacje",
  widget_group_clients: "Klienci",
  widget_group_team: "Mój zespół",
  widget_group_subscriptions: "Subskrypcje",
  widget_group_products: "Produkty",
  widget_revenue_kpi: "Przychody",
  widget_bookings_kpi: "Rezerwacje",
  widget_new_clients_kpi: "Nowi klienci",
  widget_cancellation_rate: "Wskaźnik anulacji",
  widget_top_clients: "Najlepsi klienci",
  widget_peak_hours_heatmap: "Godziny szczytu",
  widget_avg_booking_value: "Śr. wartość rezerwacji",
  widget_payment_method: "Preferowana metoda płatności",
  widget_bookings_timeline: "Rezerwacje w czasie",
  widget_booking_status: "Status rezerwacji",
  widget_busiest_day: "Najbardziej aktywny dzień",
  widget_busiest_hour: "Najbardziej aktywna godzina",
  widget_avg_lead_time: "Śr. czas wyprzedzenia",
  widget_active_clients: "Aktywni klienci",
  widget_retention_rate: "Wskaźnik retencji",
  widget_employee_utilization: "Obłożenie pracowników",
  widget_top_service: "Najlepsza usługa",
  widget_active_subscriptions: "Aktywne subskrypcje",
  widget_mrr: "Przychód z subskrypcji",
  widget_product_revenue: "Przychód z produktów",
  widget_booking_revenue: "Przychód z rezerwacji",
  widget_total_transactions: "Wszystkie transakcje",
  widget_payment_conversion: "% opłaconych rezerwacji",
  widget_revenue_timeline: "Przychody w czasie",
  widget_revenue_top_services_table: "Top usługi wg przychodu",
  widget_revenue_top_products_table: "Top produkty wg przychodu",
  widget_payment_providers_chart: "Metody płatności",
  widget_booking_status_chart: "Podział rezerwacji wg statusu",
  widget_cancellation_reasons_chart: "Powody anulowania",
  widget_busiest_day_chart: "Rezerwacje wg dnia tygodnia",
  widget_delivery_type_chart: "Podział wg typu realizacji",
  widget_customer_segments_chart: "Segmenty klientów",
  widget_top_customers_table: "Top klienci (pełna tabela)",
  widget_employee_table: "Wyniki pracowników",
  widget_service_table: "Wyniki usług",
  widget_subscription_timeline: "Nowe subskrypcje w czasie",
  widget_subscription_revenue_timeline: "Przychody z subskrypcji w czasie",
  widget_top_subscriptions_table: "Top plany subskrypcyjne",
  widget_product_revenue_timeline: "Przychody z produktów w czasie",
  widget_top_products_table: "Top produkty",
  widget_booking_revenue_timeline: "Przychody z rezerwacji w czasie",
  widget_bookings_by_service_table: "Rezerwacje wg usługi",
  widget_bookings_by_employee_table: "Najaktywniejszy zespół",
  widget_bookings_by_hour_chart: "Rezerwacje wg godziny",
  widget_locations_table: "Rezerwacje wg lokalizacji",
  widget_total_clients: "Wszyscy klienci",
  widget_customer_ltv: "Wartość klienta (LTV)",
  widget_returning_clients: "Powracający klienci",
  widget_avg_days_between_visits: "Śr. dni między wizytami",
  widget_first_time_clients: "Nowi klienci (pierwsza wizyta)",
  widget_loyal_clients: "Lojalni klienci",
  widget_services_by_category_chart: "Rezerwacje wg kategorii",
  widget_renewal_rate: "Wskaźnik odnowień",
  widget_subscription_utilization: "Wykorzystanie subskrypcji",
  widget_unused_booking_slots: "Niewykorzystane terminy",
  widget_total_products_sold: "Sprzedane produkty",
  restore_defaults: "Przywróć domyślne",
  restore_defaults_warning:
    "Spowoduje to zresetowanie pulpitu do domyślnych widżetów. Twój aktualny układ zostanie utracony.",
  drag_to_reorder: "Przeciągnij, aby zmienić kolejność",
  tooltip_add_widget: "Dodaj nowy widżet do pulpitu",
  tooltip_edit_layout: "Zmień kolejność lub usuń widżety",
  tooltip_restore_defaults: "Przywróć domyślny układ widżetów",
  tooltip_save_layout: "Zapisz aktualny układ widżetów",
  tooltip_remove_widget: "Usuń ten widżet",
  add_more_widgets: "Dodaj więcej widżetów",
  all_time: "Od początku",
  remove_from_group: "Usuń z grupy",
  change_status_to_approved: "Ustaw jako zatwierdzone",
  change_status_to_payment: "Ustaw jako oczekujące na płatność",
  change_status_to_cancelled: "Ustaw jako anulowane",
  change_status_to_done: "Ustaw jako zakończone",
  bulk_operation_already_active:
    "Masz już aktywną operację masową. Poczekaj na jej zakończenie.",
  go_to_fakturownia: "Przejdź do ustawień Fakturowni",
  invoice_no_integration_tooltip:
    "Faktura włączona, ale integracja z Fakturownią nie jest aktywna",
  affiliate: "Program poleceń",
  affiliate_page_title: "Program poleceń",
  affiliate_join_title: "Dołącz do programu poleceń",
  affiliate_join_description:
    "Udostępnij swój link i zarabiaj za każdego nowego klienta, który wykupi subskrypcję Calendesk.",
  affiliate_accept_terms: "Akceptuję regulamin programu poleceń",
  affiliate_terms_link_text: "Przeczytaj regulamin",
  affiliate_join_button: "Dołącz do programu",
  affiliate_balance_title: "Saldo programu poleceń",
  affiliate_link_title: "Twój link polecający",
  affiliate_link_description:
    "Udostępnij ten link, aby polecać nowych klientów i zarabiać.",
  affiliate_copy_link: "Kopiuj link",
  affiliate_link_copied: "Link skopiowany do schowka!",
  affiliate_request_payout: "Wypłać środki",
  affiliate_payout_method_title: "Wybierz metodę wypłaty",
  affiliate_payout_balance_credit: "Zasilenie salda",
  affiliate_payout_balance_credit_description:
    "Wykorzystaj zarobki jako kredyt na subskrypcję.",
  affiliate_payout_bank_transfer: "Przelew bankowy",
  affiliate_payout_bank_transfer_info:
    "Aby otrzymać przelew (min. {minAmount} netto), wyślij fakturę na support@calendesk.com po złożeniu wniosku.",
  affiliate_payout_bank_transfer_below_min:
    "Przelew bankowy wymaga minimum {minAmount}. Uzbieraj więcej albo skorzystaj z opcji zasilenia salda.",
  affiliate_payout_confirm: "Potwierdź wypłatę",
  affiliate_payout_success: "Wniosek o wypłatę został złożony.",
  affiliate_join_success: "Dołączyłeś do programu poleceń.",
  affiliate_no_referrals:
    "Brak poleceń. Udostępnij swój link, aby zacząć zarabiać!",
  affiliate_no_payouts: "Brak transakcji.",
  affiliate_referrals_title: "Polecenia",
  affiliate_payouts_title: "Historia transakcji",
  affiliate_status_pending: "Oczekujące",
  affiliate_status_rewarded: "Nagrodzone",
  affiliate_status_rejected: "Odrzucone",
  affiliate_status_approved: "Zatwierdzone",
  affiliate_status_completed: "Zrealizowane",
  affiliate_payout_method_balance: "Zasilenie salda",
  affiliate_payout_method_bank: "Przelew bankowy",
  affiliate_payout_method_adjustment: "Korekta salda",
  affiliate_welcome_bonus_banner:
    "Masz bonus powitalny! {amount} zniżki na pierwszą subskrypcję.",
  affiliate_welcome_bonus_applied: "Bonus powitalny: -{amount}",
  affiliate_welcome_bonus_plan_note: "-{amount} na pierwszą płatność",
  first_payment: "Pierwsza płatność",
  affiliate_welcome_bonus_dashboard_title: "Czeka na Ciebie bonus powitalny",
  affiliate_welcome_bonus_dashboard_description:
    "Odbierz {amount} zniżki na pierwszą subskrypcję Calendesk.",
  affiliate_welcome_bonus_dashboard_cta: "Wybierz plan",
  affiliate_column_tenant: "Klient",
  affiliate_column_registered: "Rejestracja",
  affiliate_column_subscribed: "Subskrypcja",
  affiliate_column_status: "Status",
  affiliate_column_reward: "Nagroda",
  affiliate_column_date: "Data",
  affiliate_column_amount: "Kwota",
  affiliate_column_method: "Typ",
  affiliate_column_note: "Powód",
  affiliate_modal_headline: "Zarabiaj polecając Calendesk",
  affiliate_modal_cta_dismiss: "Może później",
  affiliate_accept_terms_with_link_prefix: "Akceptuję",
  affiliate_accept_terms_with_link_anchor: "regulamin programu poleceń",
  affiliate_total_earned: "Łączne zarobki",
  affiliate_total_paid: "Wypłacono",
  affiliate_hero_badge_new: "NOWOŚĆ",
  affiliate_hero_badge_label: "Program poleceń dla Twojej firmy",
  affiliate_hero_headline_main: "Udostępnij link. Zarabiaj na każdej",
  affiliate_hero_headline_accent: "rezerwacji.",
  affiliate_hero_subhead:
    "Każdy nowy klient, którego polecisz, to prowizja dla Ciebie, wypłacana automatycznie. Wszystko widzisz na żywo w panelu Calendesk.",
  affiliate_hero_cta_primary: "Dołącz do programu",
  affiliate_hero_cta_secondary: "Zobacz regulamin",
  affiliate_hero_headline:
    "Polecaj Calendesk: 50 zł dla Ciebie i 50 zł dla nowej firmy!",
  affiliate_hero_lead:
    "Zaakceptuj regulamin, dołącz do programu i odbierz swój link polecający. Za każdego klienta, który założy konto w Calendesk i opłaci subskrypcję, otrzymasz nagrodę. Zyska na tym również osoba polecona, która otrzyma bonus powitalny.",
  affiliate_hero_fine_print:
    "Program trwa od 01.04.2026 do 31.03.2028. Limit 2 000 zł brutto dla osób bez działalności gospodarczej. Rozliczenia w PLN, USD, EUR lub GBP.",
  affiliate_reward_you_label: "Ty otrzymujesz",
  affiliate_reward_you_amount: "50 zł",
  affiliate_reward_you_suffix: "netto",
  affiliate_reward_you_note: "za każdą nową firmę w Calendesk",
  affiliate_reward_new_label: "Nowa firma otrzymuje",
  affiliate_reward_new_amount: "50 zł",
  affiliate_reward_new_suffix: "netto",
  affiliate_reward_new_note: "kod rabatowy na subskrypcję Calendesk",
  affiliate_preview_copy: "Kopiuj",
  affiliate_preview_saldo_label: "Saldo · ten miesiąc",
  affiliate_preview_delta: "+7 poleceń",
  affiliate_preview_last_reward_title: "Ostatnia nagroda",
  affiliate_preview_paid_out: "Wypłacono",
  affiliate_preview_recent_title: "Ostatnie polecenia",
  affiliate_preview_recent_count: "7 w tym miesiącu",
  affiliate_preview_col_business: "Firma",
  affiliate_preview_col_reward: "Nagroda",
  affiliate_preview_col_status: "Status",
  affiliate_preview_status_reward: "NAGRODA",
  affiliate_preview_status_30days: "30 DNI",
  affiliate_hero_preview_link_title: "Twój link polecający",
  affiliate_hero_preview_link_description:
    "Wyślij go klientom i znajomym. Prowizja jest Twoja.",
  affiliate_hero_preview_this_month: "Ten miesiąc",
  affiliate_hero_preview_trend: "+34% vs. zeszły miesiąc",
  affiliate_hero_preview_recent_title: "Ostatnie polecenia",
  affiliate_hero_preview_recent_count: "12 w tym miesiącu",
  affiliate_hero_sample_data:
    "Dane przykładowe. Twoje liczby pojawią się po dołączeniu.",
  affiliate_hero_preview_label: "Podgląd",
  affiliate_announcement_title: "Zgarnijcie po 50 zł - Ty i Twoi znajomi!",
  affiliate_announcement_description:
    "Udostępnij swój link. Gdy nowa firma opłaci subskrypcję, oboje otrzymacie po 50 zł.",
  affiliate_announcement_description_2:
    "Nagrodę wypłacisz przelewem lub wykorzystasz na opłacenie własnego konta Calendesk.",
  affiliate_announcement_cta_learn_more: "Dowiedz się więcej",
  affiliate_announcement_cta_dismiss: "Może później",
  affiliate_hero_benefit_1:
    "Zarabiasz od każdej nowej subskrypcji. Bez limitu poleceń*",
  affiliate_hero_benefit_2:
    "Polecona firma dostaje kod rabatowy na subskrypcję",
  affiliate_hero_benefit_3: "Śledzisz polecenia na żywo w panelu",
  affiliate_suspended_title: "Twój program partnerski jest zawieszony",
  affiliate_suspended_message:
    "Nowe wypłaty są wstrzymane, a zespół Calendesk weryfikuje Twoje konto. Masz pytania? Napisz do wsparcia.",
  affiliate_rejection_cancelled_before_30d:
    "Polecony klient zrezygnował przed upływem 30 dni od subskrypcji.",
  affiliate_rejection_duplicate_tenant:
    "Polecony klient miał już konto w naszym systemie.",
  affiliate_rejection_fraud:
    "Polecenie oznaczone jako nieautoryzowane lub naruszające regulamin.",
  affiliate_rejection_lifetime_cap_exceeded:
    "Twój program osiągnął maksymalny limit zarobków.",
  affiliate_rejection_note_label: "Notatka od wsparcia:",
  affiliate_leave_program: "Opuść program partnerski",
  affiliate_leave_dialog_title: "Opuścić program partnerski?",
  affiliate_leave_dialog_warning:
    "Przestaniesz zbierać nowe nagrody, a Twój link partnerski przestanie działać.",
  affiliate_leave_dialog_rejoin_hint:
    "Możesz wrócić w każdej chwili. Kod i historia są zachowane.",
  affiliate_leave_dialog_confirm: "Opuść program",
  affiliate_leave_success: "Nie uczestniczysz już w programie partnerskim.",
  affiliate_preview_copy_locked:
    "Zaakceptuj regulamin i dołącz do programu, aby wygenerować link.",
  fakturownia_department_id_title: "ID działu",
  fakturownia_department_id_hint: "Zostaw puste, aby użyć domyślnego działu.",
  fakturownia_department_id_description:
    "Numeryczne ID działu w Fakturowni, który ma wystawiać faktury z Calendesk. Każdy dział może mieć własne dane sprzedawcy i własne domyślne uwagi — przydatne, gdy jedno konto Fakturowni obsługuje kilka kanałów sprzedaży (np. Shopify + Calendesk).",
  fakturownia_additional_settings_title: "Ustawienia dodatkowe",
  fakturownia_additional_settings_subtitle:
    "Te pola są opcjonalne i nie są wymagane do podstawowej integracji. Wypełnij je tylko wtedy, gdy chcesz dostosować sposób wystawiania faktur.",
  fakturownia_credentials_error:
    "Nie udało się połączyć z Fakturownią. Sprawdź API token i adres konta.",
  fakturownia_department_id_single_hint:
    "Twoje konto Fakturowni ma tylko jeden dział. Utwórz kolejny dział w Fakturowni, aby kierować do niego faktury z Calendesk.",
  fakturownia_department_id_no_results:
    "Nie znaleziono działów na tym koncie Fakturowni.",
  google_calendar_auth_error:
    "Nie udało się połączyć Kalendarza Google, ponieważ odmówiono dostępu lub nie przyznano wszystkich wymaganych uprawnień. Spróbuj ponownie i zezwól na dostęp do kalendarza.",
  gov_status_demo_ok: "Demo (zaakceptowana)",
};
